// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Badge } from "@/components/ui/badge";

const REALM_STYLES: Record<string, string> = {
  local: "bg-gray-100 text-gray-600 border-gray-200 dark:bg-gray-900 dark:text-gray-400 dark:border-gray-800",
  morrisons: "bg-green-100 text-green-700 border-green-200 dark:bg-green-950 dark:text-green-300 dark:border-green-900",
  lidl: "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-900",
  walmart:
    "bg-yellow-100 text-yellow-700 border-yellow-200 dark:bg-yellow-950 dark:text-yellow-300 dark:border-yellow-900",
};

// Deterministic color pool for unknown realms
const COLOR_POOL = [
  "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-900",
  "bg-purple-100 text-purple-700 border-purple-200 dark:bg-purple-950 dark:text-purple-300 dark:border-purple-900",
  "bg-teal-100 text-teal-700 border-teal-200 dark:bg-teal-950 dark:text-teal-300 dark:border-teal-900",
  "bg-orange-100 text-orange-700 border-orange-200 dark:bg-orange-950 dark:text-orange-300 dark:border-orange-900",
  "bg-rose-100 text-rose-700 border-rose-200 dark:bg-rose-950 dark:text-rose-300 dark:border-rose-900",
  "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-900",
  "bg-indigo-100 text-indigo-700 border-indigo-200 dark:bg-indigo-950 dark:text-indigo-300 dark:border-indigo-900",
  "bg-sky-100 text-sky-700 border-sky-200 dark:bg-sky-950 dark:text-sky-300 dark:border-sky-900",
];

function hashRealm(realm: string): number {
  let h = 0;
  for (let i = 0; i < realm.length; i++) h = (h * 31 + realm.charCodeAt(i)) >>> 0;
  return h % COLOR_POOL.length;
}

export function RealmBadge({ realm }: { realm: string }) {
  const className = REALM_STYLES[realm] ?? COLOR_POOL[hashRealm(realm)];
  return (
    <Badge variant="outline" className={`font-normal ${className}`}>
      {realm}
    </Badge>
  );
}
